import { CrownFrame } from "@/components/CrownFrame";
import { WolfLink } from "@/pages/WolfPage";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gem } from "lucide-react";
import { api } from "@/lib/api";
import { DropBadges } from "@/components/GoldBadge";

const MEDAL = ["text-amber-300", "text-slate-200", "text-orange-300"];

export default function HolderBoard({ limit = 20, compact = false }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/holders/top").then(({ data }) => setD(data)).catch(() => setErr(true)); }, []);
  const p = compact ? "gallery-holders" : "lb-holders";
  if (err) return <p className="text-red-300 text-sm" data-testid={`${p}-error`}>Couldn't load the holders. Please refresh to try again.</p>;
  if (!d) return <p className="text-slate-500 text-sm">Counting the collectors…</p>;
  const rows = d.holders.slice(0, limit);
  return (
    <section data-testid={p} className={compact ? "glass rounded-2xl p-5 mb-10" : "space-y-3"}>
      {compact && <div className="flex flex-wrap items-baseline justify-between gap-2 mb-4">
        <h2 className="font-display text-xl text-amber-100 flex items-center gap-2"><Gem className="w-4 h-4 text-emerald-300" />Top holders</h2>
        <Link to="/leaderboard" className="text-xs text-cyan-300 hover:underline" data-testid={`${p}-more`}>Full board</Link>
      </div>}
      {!rows.length ? <p className="text-sm text-slate-500" data-testid={`${p}-empty`}>No 1/1 Wolf NFTs are held by linked players yet. Claim yours and link your Solana wallet to top the board.</p> : (
        <ol className={compact ? "grid sm:grid-cols-2 lg:grid-cols-5 gap-3" : "space-y-3"}>
          {rows.map((e) => (
            <li key={e.rank} data-testid={`${p}-row-${e.rank}`}
              className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 transition-colors hover:border-amber-400/50 ${e.rank <= 3 ? "border-amber-400/30 bg-amber-500/5" : "border-slate-800 bg-slate-950/60"}`}>
              <span className={`font-display text-xl w-7 text-center ${MEDAL[e.rank - 1] || "text-slate-500"}`}>{e.rank}</span>
              <CrownFrame tier={e.mwp_tier} small className="rounded-xl"><img src={e.portrait} alt={e.wolf_name} loading="lazy" className={`${compact ? "w-10 h-10" : "w-14 h-14"} rounded-xl object-cover border border-slate-700`} /></CrownFrame>
              <div className="min-w-0 flex-1">
                <p className="text-white font-semibold truncate flex items-center gap-1.5"><WolfLink name={e.wolf_name} testid={`${p}-link-${e.rank}`} className="truncate" /><DropBadges o={e} testid={`${p}-${e.rank}`} /></p>
                <p className="text-xs text-slate-400" data-testid={`${p}-count-${e.rank}`}>{e.count} {e.count === 1 ? "wolf" : "wolves"} held</p>
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
